import React from 'react'
import styles from "../myprofile/myprofile.module.css"
import Myprofile from '../myprofile/Myprofile'
import ExcessStockTab from '../../Components/excessStock/ExcessStock'

const ExcessStocks = () => {
    return (
        <>
            <Myprofile className={styles.myprofile}>
                <ExcessStockTab />
            </Myprofile>
        </>
    )
}

export default ExcessStocks